<template lang="pug">
  #itinerary.right-panel.md-elevation-1.md-scrollbar.md-theme-default
    .entity-card
      .md-layout-row.entity-card-head
        .md-layout-item.entity-head-left
          span(v-if="$route.params.id") {{'Маршрутный лист №' + $route.params.id}}
          .status(v-if="result.status" v-bind:style="'color: ' + (result.status.color ? result.status.color : 'balck') + ';'") {{result.status.message}}
          md-button.md-icon-button.md-dense.close.small.full-price-btn(v-if="$route.params.id && $route.params.id != 'new'" v-on:click="updateRoutelistStatus($route.params.id)")
            i.fas.fa-sync-alt
            md-tooltip(md-direction="bottom" md-delay="500") Обновить статус МЛ
            
          z-button.acceptauto(v-on:click="acceptAuto()" v-if="canAcceptAuto") Принять машину на складе

        .md-layout-item.entity-head-center
        .md-layout-item.entity-head-right
          md-button.md-primary.md-icon-button.md-dense.close.small(v-if="canSave" v-on:click="save")
            md-icon check
            md-tooltip(md-direction="bottom" md-delay="500") Сохранить
          md-button.md-icon-button.md-dense.close.small(v-on:click="back")
            md-icon close
            md-tooltip(md-direction="bottom" md-delay="500") Отменить

      .entity-card-body(v-loader-overlay="progress")
        flex-tabs(v-bind:tabs="tabs" v-model="activeTab" min)

        .md-layout-item.entity-head-tight(v-if="activeTab === 'tab-comments' && routeList && routeList.id && routeList.id != 'new'")
          comments-and-logs(v-bind:entity_id="routeList.id" entity="deals_routelist" module="deals")

        .md-layout-item.entity-head-tight(v-show="activeTab === 'tab-routelist'")
          .md-body-1
            .sum-data-title Суммарная информация по выбранным грузам
            .sum-data
              .sum-data-item(md-with-hover)
                span {{'Вec (кг): '}}
                b {{round(result.weight)}}
              .sum-data-item(md-with-hover) 
                span(v-html="'Объём (м<sup>3</sup>): '")
                b {{round(result.volume)}}
              .sum-data-item(md-with-hover)
                span {{'Мест: '}}
                b {{result.seats}}
                
            .direction-container
              span.md-subheading(v-if="!canEditFouteList") Маршрутный лист находится в работе, редактирование недоступно
              .direction-area__container
                .direction-area
                  z-big-select(
                      label="Тип перевозки" name="forward_type" id="forward_type"
                      v-model="result.forward_type" v-bind:required="true" v-bind:disabled="!canEditFouteList"
                      v-validate="{'required': true}" v-bind:error="errors.first('forward_type')" icon='<i class="far fa-clipboard"></i>'
                  )
                    z-select-item(v-for="item in types" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.value" v-on:click="clearData") 
                .direction-area
                  z-big-date(
                      v-bind:label="((parseInt(result.forward_type) === 1) ? 'Дата экспедирования' : 'Дата перевозки')" id="date" name="date"
                      v-model="result.date" v-bind:required="true" v-bind:disabled="!canEditFouteList"
                      v-validate="'required'" v-bind:error="errors.first('date')"
                  )
                .direction-area(v-if="result && result.forward_type" v-show="parseInt(result.forward_type) === 2")
                  z-big-select(
                    v-if="fromStocks && fromStocks.length && parseInt(result.forward_type) === 2"
                    id="from_stock_id" name="from_stock_id" label="Склад отправления"
                    v-model="result.from_stock_id" v-bind:required="true" v-bind:disabled="!canEditFouteList"                 
                    icon='<i class="fas fa-warehouse"></i>'
                    v-validate="{'required': (parseInt(result.forward_type) === 2)}" v-bind:error="errors.first('from_stock_id')" v-bind:data-vv-as="' '"
                  )
                    z-select-item(v-for="item in fromStocks" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.name" v-on:click="clearFromData")

                  z-big-select(
                    v-if="responsiblesFrom && responsiblesFrom.length && parseInt(result.forward_type) === 2"
                    label="Кладовщик в пункте отправления" id="from_storekeeper_id" name="from_storekeeper_id"
                    v-model="result.from_storekeeper_id" :required="true" v-bind:disabled="!canEditFouteList"
                    v-validate="{'required': (parseInt(result.forward_type) === 2)}" v-bind:error="errors.first('from_storekeeper_id')" v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-people-carry"></i>'
                  )
                    z-select-item(v-for="item in responsiblesFrom" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.login")

                  z-big-select(
                    v-if="result.from_stock_id && drivers && drivers.length && parseInt(result.forward_type) === 2"
                    label="Водитель" id="driver_id" name="driver_id"
                    v-model="result.driver_id" :required="true" v-bind:disabled="!canEditFouteList"
                    v-validate="{'required': (parseInt(result.forward_type) === 2)}" v-bind:error="errors.first('driver_id')" v-bind:data-vv-as="' '"
                    icon='<i class="fa fa-user"></i>'
                  )
                    z-select-item(v-for="item in drivers" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.label")
                  
                .direction-area(v-if="result && result.forward_type" v-show="parseInt(result.forward_type) === 2")
                  z-big-select(
                    v-if="toStocks && toStocks.length && parseInt(result.forward_type) === 2"
                    id="to_stock_id" name="to_stock_id" label="Склад назначения"
                    v-model="result.to_stock_id" :required="true" v-bind:disabled="!canEditFouteList"
                    v-validate="{'required': (parseInt(result.forward_type) === 2)}" v-bind:error="errors.first('to_stock_id')" v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-warehouse"></i>'
                  )
                    z-select-item(v-for="item in toStocks" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.name" v-on:click="clearToData")

                  z-big-select(
                    v-if="responsiblesTo && responsiblesTo.length && parseInt(result.forward_type) === 2"
                    id="to_storekeeper_id" name="to_storekeeper_id" label="Кладовщик в пункте назначения"
                    v-model="result.to_storekeeper_id" :required="true" v-bind:disabled="!canEditFouteList"
                    v-validate="{'required': (parseInt(result.forward_type) === 2)}" v-bind:error="errors.first('to_storekeeper_id')" v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-people-carry"></i>'
                  )
                    z-select-item(v-for="item in responsiblesTo" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.login")

                  z-big-select(
                    v-if="responsiblesTo && responsiblesTo.length && parseInt(result.forward_type) === 2"
                    id="to_chief_id" name="to_chief_id" label="Ответственный за прием машины в пункте назначения"
                    v-model="result.to_chief_id" :required="true" v-bind:disabled="!canEditFouteList"
                    v-validate="{'required': (parseInt(result.forward_type) === 2)}" v-bind:error="errors.first('to_chief_id')" v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-user-check"></i>'
                  )
                    z-select-item(v-for="item in responsiblesTo" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.login")

                .direction-area.full-width(v-if="result && result.forward_type" v-show="parseInt(result.forward_type) === 1")
                  z-big-select(
                    v-if="stocks && stocks.length && parseInt(result.forward_type) === 1"
                    name="stock_id" id="stock_id" label="Склад экспедирования"
                    v-model="result.stock_id" :required="true" v-bind:disabled="!canEditFouteList"
                    v-validate="{'required': (parseInt(result.forward_type) === 1)}" v-bind:error="errors.first('stock_id')" v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-warehouse"></i>'
                  )
                    z-select-item(v-for="item in stocks" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.name" v-on:click="clearForwardData")

                .direction-area(v-if="result && result.forward_type" v-show="parseInt(result.forward_type) === 1")
                  z-big-select(
                    v-if="forwarders && forwarders.length && parseInt(result.forward_type) === 1"
                    id="forwarder_id" name="forwarder_id" label="Ответственный экспедитор"
                    v-model="result.forwarder_id" :required="true" v-bind:disabled="!canEditFouteList"
                    v-validate="{'required': (parseInt(result.forward_type) === 1)}" v-bind:data-vv-as="' '" v-bind:error="errors.first('forwarder_id')"
                    icon='<i class="fas fa-truck-loading"></i>'
                  )
                    z-select-item(v-for="item in forwarders" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.login")

                .direction-area(v-if="result && result.forward_type && parseInt(result.forward_type) === 1")
                  z-big-select(
                    v-if="storekeepres && storekeepres.length && parseInt(result.forward_type) === 1"
                    id="storekeeper_id" name="storekeeper_id" label="Ответственный кладовщик"
                    v-model="result.storekeeper_id" :required="true" v-bind:disabled="!canEditFouteList"
                    v-validate="{'required': (parseInt(result.forward_type) === 1)}" v-bind:error="errors.first('storekeeper_id')" v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-people-carry"></i>'
                  )
                    z-select-item(v-for="item in storekeepres" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.login")
              
              .direction-area__container
                .direction-area(v-if="vansAndTractors && vansAndTractors.length")
                  z-big-select(
                    id="auto_id" name="auto_id" label="Автомобиль"
                    v-model="result.auto_id" :required="true" v-bind:disabled="!canEditFouteList"
                    v-validate="{'required': true}" v-bind:error="errors.first('auto_id')" v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-truck"></i>'
                  )
                    z-select-item(v-for="item in vansAndTractors" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.label")
                
                .direction-area(v-if="trailers && trailers.length")
                  z-big-multy-select(
                    id="trailers" name="trailers" label="Прицеп"
                    v-model="result.trailers" :required="false" v-bind:disabled="!canEditFouteList"
                    v-validate="{'required': false}" v-bind:error="errors.first('trailers')" v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-trailer"></i>'
                  )
                    z-multy-select-item(
                      v-for="item in trailers" 
                      v-bind:value="item.id" 
                      v-bind:key="item.id" 
                      v-bind:label="item.label"
                      v-bind:selected="(result.trailers && (result.trailers.indexOf(item.id) + 1)) ? true : false"
                    )

                .direction-area(v-if="agents && agents.length")
                  z-big-select(
                    id="agent_id" name="agent_id" label="Перевозчик"
                    v-model="result.agent_id" :required="true" v-bind:disabled="!canEditFouteList"
                    v-validate="{'required': true}" v-bind:error="errors.first('agent_id')" v-bind:data-vv-as="' '"
                    icon='<i class="fas fa-user-tie"></i>'
                  )
                    z-select-item(v-for="item in agents" v-bind:value="item.id" v-bind:key="item.id" v-bind:label="item.label")

            //Поле добавления груза в МЛ, отключенно т.к. не используется пользователями
            //autocomplete(name="add_freight" v-model="addFreight" property="traking_number" return="id" v-bind:return-all="true" v-bind:clear-after-select="true" label="Добавить груз" v-bind:callback="filterFreight")

            .freight-list-title.error(v-if="errors && errors.items && errors.items.length")
              span.error В параметрах маршрутного листа есть ошибки, пожалуйста исправьте их
            .freight-list-title.error(v-if="!selectedFreights || !selectedFreights.length")
              span.error Грузы не выбраны



            toggle-card(:visibility="true" v-bind:heading="`Выбранные грузы ${ calcDimensionsStr(newFreights, newFreights.length) }`" v-if="newFreights && newFreights.length")
              .freight-list(v-if="newFreights && newFreights.length")
                div(v-for="(freight, i) in newFreights" v-bind:key="('zrl-' + i + '-' + freight.id)")
                  ZRLFreight(
                    v-bind:freight="freight"
                    v-bind:error="(freightsErrors[freight.id]) ? freightsErrors[freight.id] : null"
                    v-bind:warning="(freightsWarnings[freight.id]) ? freightsWarnings[freight.id] : null"
                    v-bind:doomMarkup="doomMarkup"
                    v-on:remove="removeFreight(freight)"
                    v-bind:show-remove="true"
                    v-bind:showForwardTypeLabel="(parseInt(result.forward_type) === 1 ? true : false)"
                    v-bind:forward-method="((freight.current_forward_method) ? parseInt(freight.current_forward_method) : getFreightForwardMethod(freight))"
                  )
                  div.freight-list__intermediate-dimensions(v-html="calcDimensionsStr(newFreights, i)")

            toggle-card(:visibility="true" v-bind:heading="`Не обработанные грузы ${ calcDimensionsStr(notCompletedFreights, notCompletedFreights.length) }`" v-if="notCompletedFreights && notCompletedFreights.length")
              span.error(v-if="hasFreightsErrors") (В списке грузов есть ошибки. Проверьте список грузов.)
              .freight-list(v-if="notCompletedFreights && notCompletedFreights.length")
                div(v-for="(freight, i) in notCompletedFreights" v-bind:key="('zrl-' + i + '-' + freight.id)")
                  ZRLFreight(
                    v-bind:freight="freight"
                    v-bind:error="(freightsErrors[freight.id]) ? freightsErrors[freight.id] : null"
                    v-bind:warning="(freightsWarnings[freight.id]) ? freightsWarnings[freight.id] : null"
                    v-bind:doomMarkup="doomMarkup"
                    v-on:remove="removeFreight(freight)"
                    v-bind:show-remove="true"
                    v-bind:showForwardTypeLabel="(parseInt(result.forward_type) === 1 ? true : false)"
                    v-bind:forward-method="((freight.current_forward_method) ? parseInt(freight.current_forward_method) : getFreightForwardMethod(freight))"
                  )
                  div.freight-list__intermediate-dimensions(v-html="calcDimensionsStr(notCompletedFreights, i)")

            toggle-card(:visibility="true" v-bind:heading="`Обработанные грузы ${ calcDimensionsStr(completedFreights, completedFreights.length) }`" v-if="completedFreights && completedFreights.length")
              .freight-list(v-if="completedFreights && completedFreights.length")
                div(v-for="(freight, i) in completedFreights" v-bind:key="('zrl-' + i + '-' + freight.id)")
                  ZRLFreight(
                    v-bind:freight="freight"
                    v-bind:error="(freightsErrors[freight.id]) ? freightsErrors[freight.id] : null"
                    v-bind:warning="(freightsWarnings[freight.id]) ? freightsWarnings[freight.id] : null"
                    v-bind:doomMarkup="doomMarkup"
                    v-on:remove="removeFreight(freight)"
                    v-bind:show-remove="true"
                    v-bind:showForwardTypeLabel="(parseInt(result.forward_type) === 1 ? true : false)"
                    v-bind:forward-method="((freight.current_forward_method) ? parseInt(freight.current_forward_method) : getFreightForwardMethod(freight))"
                  )
                  div.freight-list__intermediate-dimensions(v-html="calcDimensionsStr(completedFreights, i)")
            
      .entity-card-footer
        md-button.md-primary.small(v-if="($route.params.id && $route.params.id != 'new')" v-on:click="printDoc") Распечатать
</template>
<script>
  import moment from "moment"
  import ZSelect from '@/components/ZSelect';
  import ZSelectItem from '@/components/ZSelectItem';
  import ZBigSelect from '@/components/ZBigSelect';
  import ZBigMultySelect from '@/components/ZBigMultySelect';
  import ZMultySelectItem from '@/components/ZMultySelectItem';
  import ZBigDate from '@/components/ZBigDate';
  import ZRLFreight from '@/components/ZRLFreight';
  import ZButton from '@/components/ZButton';
  import autocomplete from '@/components/autocomplete'
  import ToggleCard from '@/components/ToggleCard'
  import RoutelistValidator from '@/helpers/RoutelistValidator'
  import commentsAndLogs from '@/components/CommentsAndLogs';
  import FlexTabs     from '@/components/FlexTabs';
  export default {
    components: {
      autocomplete, ZBigSelect, ZBigMultySelect, ZMultySelectItem, ZSelect, FlexTabs,
      ZSelectItem, ZBigDate, ZRLFreight, ToggleCard, ZButton, commentsAndLogs
    },
    data() {
      return {
        loadKey: 'load-itirnary-card',
        addFreight: {},
        selectedFreightsId: [],
        selectedFreights:[],
        responsibleItems: [],
        stockErrors: [],
        freightsErrors: {},
        freightsWarnings: {},
        canSave: true,
        responsibles: [],
        responsiblesFrom: [], //список кладовщиков на складе отправления
        responsiblesTo: [],   //список кладовщиков на складе назначения
        forwarders: [],       //список экспедиторов
        storekeepres: [],
        drivers: [],          //водителей
        autos: [],
        agents: [],
        doomMarkup: 0,
        /*types: [
          {id: 1, value: 'Забор у отправителя'},
          {id: 2, value: 'Выдача получателю'},
          {id: 3, value: 'Внутренняя перевозка'},
        ],*/
        types: [
          {id: 1, value: 'Экспедирование'},
          {id: 2, value: 'Внутренняя перевозка'},
        ],
        activeTab: 'tab-routelist',
        tabs: [
          {name: "tab-routelist", label: "Маршрутный лист"},
          {name: "tab-comments",  label: "История"},
        ],
        currentStockId: null, //id склада, где находятся грузы
        currentCityId: null,
        result: {
          weight: 0,
          volume: 0,
          seats: 0,
          date: null,
          city: '',
          forwarder_id: null,
          from_storekeeper_id: null,
          to_storekeeper_id: null,
          storekeeper_id: null,
          to_chief_id: null,
          from_stock_id: null,
          to_stock_id: null,
          forward_type: null,
          driver_id: null,
          stock_id: null,
          auto_id: null,
          agent_id: null,
          trailers: [],
          freights: [],
          removed: [],
        },
        resultDefault: {
          weight: 0,
          volume: 0,
          seats: 0,
          date: null,
          city: '',
          forwarder_id: null,
          from_storekeeper_id: null,
          to_storekeeper_id: null,
          storekeeper_id: null,
          to_chief_id: null,
          from_stock_id: null,
          to_stock_id: null,
          forward_type: null,
          driver_id: null,
          stock_id: null,
          auto_id: null,
          agent_id: null,
          trailers: [],
          freights: [],
          removed: [],
        },
        routeList: {},
        hasFreightsErrors: false, //показывает, есть ли ошибки у грузов
      }
    },
    computed: {
      progress() {
        return this.progressObj[this.loadKey];
      },
      progressObj() {
        return this.$store.state.progressObj;
      },
      stateSelectedFreight() {
        return this.$store.state.stock.itineraryFreight
      },
      storeResponsibles() {
        return this.$store.state.stock.responsibles;
      },
      allFreights() {
        let freights = [], freight = {};
        if (this.$store.state.deals.deals && this.$store.state.deals.deals.length)
            this.$store.state.deals.deals.map(deal => {
                freight = Object.assign({}, deal.first_freight);
                freights.push(freight);
            });
        return freights;
      },
      stocks() {
        return (this.$store.state.stock && this.$store.state.stock.stocks) ? this.$store.state.stock.stocks : [];
      },
      fromStocks() {
        return (this.$store.state.stock && this.$store.state.stock.from_stocks) ? this.$store.state.stock.from_stocks : [];
      },
      toStocks() {
        return (this.$store.state.stock && this.$store.state.stock.to_stocks) ? this.$store.state.stock.to_stocks : [];
      },
      user() {
        return this.$store.state.users.current;
      },
      isUserAdmin() {
        return (this.user && this.user.groups_codes) ? !!(this.user.groups_codes.indexOf('administrators')+1) : false;
      },
      endpoint() {
        return this.$store.state.endpoint;
      },
      newFreights() {
        if (this.$route.params.id && this.$route.params.id != 'new') return [];
        return this.selectedFreights;
      },
      completedFreights() {
        if (!this.$route.params.id || this.$route.params.id == 'new') return [];
        return this.selectedFreights.filter(item => !!item.is_current_routelist_completed);
      },
      notCompletedFreights() {
        if (!this.$route.params.id || this.$route.params.id == 'new') return [];
        return this.selectedFreights.filter(item => !item.is_current_routelist_completed);
      },
      //Автофургоны и Тягачи
      vansAndTractors() {
        if (!this.autos || !this.autos.length) return [];
        return this.autos.filter(auto => {
          return (parseInt(auto.type) === 1 || parseInt(auto.type) === 2);
        }).map(auto => {
          return {id: auto.id, label: (auto.brand + ', ' + auto.number)};
        });
      },
      //Прицепы
      trailers() {
        if (!this.autos || !this.autos.length) return [];
        return this.autos.filter(auto => {
          return (parseInt(auto.type) === 3);
        }).map(auto => {
          return {id: auto.id, label: (auto.brand + ', ' + auto.number)};
        });
      },
      canAcceptAuto() {
        //Нельзя принять машину, если
        if (
          !this.$route.params.id || this.$route.params.id == 'new' || // Если это новый МЛ
          parseInt(this.routeList.status_id) === 3 || // или он уже в статусе "Машина принята"
          parseInt(this.routeList.status_id) === 5 || // или он уже в статусе "Выполнен"
          parseInt(this.routeList.type) !== 2 || // или тип МЛ "Экспедирование"
          !this.routeList.freights || !this.routeList.freights.length // или в нём нет грузов
        ) return false;

        let SuppurtedFreigts = this.routeList.freights.filter(freight => (
          freight && freight.id && freight.currenttracking &&
          freight.currenttracking.status && freight.currenttracking.status.code &&
          freight.currenttracking.status.code === "storekeeper_issued_for_delivery"
        ));
        //Так же нельзя выставить статус, если не все грузы были выданы на перемещение
        return (this.isUserAdmin && SuppurtedFreigts.length === this.routeList.freights.length);
      },
      canEditFouteList() {
        return (this.routeList && this.routeList.status_id && parseInt(this.routeList.status_id) !== 1 && !this.isUserAdmin) ? false : true;
      }
    },
    watch: {
        '$route.path'() {
          this.init();
          this.$store.commit('adaptiveSizePanel');
          this.$store.commit('openRightPanel');
        },
        'result.from_stock_id'(id, oldId) {
          if (id) {
            this.getResponsibles(id, ['storekeepers', 'agent']).then(r => {
              if (r) this.responsiblesFrom = Object.assign([], r);
              else   this.responsiblesFrom = [];
            });
            if (parseInt(this.result.forward_type) === 1) this.getResponsibles(id, ['forwarders', 'agent']).then(r => {
              if (r) this.forwarders = Object.assign([], r);
              else   this.forwarders = [];
            });
          }
          this.$nextTick(() => this.validateFreights());
        },
        'result.to_stock_id'(id, oldId) {
          if (id) this.getResponsibles(id, ['storekeepers', 'agent']).then(r => {
            if (r) this.responsiblesTo = Object.assign([], r);
            else   this.responsiblesTo = [];
          });
          this.$nextTick(() => this.validateFreights());
        },
        'result.stock_id'(id, oldId) {
            if (id) {
              this.getResponsibles(id, ['forwarders', 'agent']).then(r => {
                if (r) this.forwarders = Object.assign([], r);
                else this.forwarders = [];
              });

              this.getResponsibles(id, ['storekeepers', 'agent']).then(r => {
                if (r) this.storekeepres = Object.assign([], r);
                else   this.storekeepres = [];
              });
            }
            this.$nextTick(() => this.validateFreights());
        },
        'result.forward_type'(type, typeOld) {
          this.getFreights();
          this.$nextTick(() => this.validateFreights());
        },
        'stateSelectedFreight'(val) {
          //if (this.$route.params.id && this.$route.params.id != 'new') return;

          if (!val || !val.length) this.selectedFreights = []; //Случай когда удаляется послдений груз из МЛ
          if (val && val.length) this.getFreights();
          else if (this.$route.name == 'ItineraryFreights' && (!this.$route.params.id || this.$route.params.id == 'new')) {
            this.selectedFreights = [];
            this.$router.go(-1);
          }
        },
        'addFreight'(val) {
            if (!val || !Object.keys(val) || !val.id) return;
            if (!(this.result.freights.indexOf(val.id)+1)) {
              let value = Object.assign({}, val);
              let itemVolume = this.prepareFreightVolume(value);

              // Увеличиваем значение если необходима обрешетка
              if (parseInt(value.doom) === 1 && this.doomMarkup > 0) { 
                value.weight = parseFloat(value.weight) + ((parseFloat(value.weight) * this.doomMarkup) / 100);
                itemVolume   = parseFloat(itemVolume)   + ((parseFloat(itemVolume)   * this.doomMarkup) / 100);
              }

              this.result.weight = this.result.weight + parseFloat(value.weight);
              this.result.volume = parseFloat(this.result.volume) + itemVolume;
              this.result.seats  = this.result.seats  + parseInt(value.seats_number);

              this.selectedFreights.push(value);
              this.result.freights.push(value.id);
              this.addFreight = {};
              this.stockErrors = [];
            }
        },
        'selectedFreights'(val, old) {
          if (val && val.length) this.validateFreights();
        },
        'result.date'() {
          this.stockErrors = [];
          this.validateFreights();
        },
    },
    methods: {
      init() {
        this.result = Object.assign({}, this.resultDefault);
        
        
        Promise.all([
          this.getStocks(),
          this.getFromStocks(),
          this.getToStocks(),
          this.getDrivers(),
          this.getAutos(),
          this.getAgents(),
          this.getDoomMarkup(),
        ]).finally(r => {
          if (this.$route.params.id && this.$route.params.id != 'new') {
            this.$store.commit('stock/changeItineraryFreight', []);
            this.$store.commit('showSnackbar', ['Получение данных маршрутного листа, пожалуйста дождитесь полной загрузки формы...', 6000]);
            this.getRouteList(this.$route.params.id);
            this.result.id = this.$route.params.id;
          } else {
            this.result.date = moment().format('YYYY-MM-DD') + 'T00:00:00.000Z';
            this.getFreights();
          }
        });

        this.$store.commit('openRightPanel');
        this.$store.commit('adaptiveSizePanel');

        this.$validator.localize('ru', {
          attributes: {
            weight: 'Общий вес',
            volume: 'Общий объём',
            seats: 'Количество мест',
            date: 'Дата',
            forwarder_id: 'Экспедитор',
            freights: 'Грузы',
            forward_type: 'Тип перевозки',
            to_stock_id: 'Склад отправления',
            from_stock_id: 'Склад назначения',
            from_storekeeper_id: 'Кладовщик на складе отправления',
            to_storekeeper_id: 'Кладовщик на складе назначения',
            to_chief_id: 'Ответственный за прием машины на складе назначения',
          }
        });
      },
      clearFromData() {
        this.result.forwarder_id        = null;
        this.result.from_storekeeper_id = null;
        this.result.driver_id           = null;
      },
      clearToData() {
        this.result.forwarder_id        = null;
        this.result.driver_id           = null;
        this.result.to_storekeeper_id   = null;
        this.result.to_chief_id         = null;
      },
      clearForwardData() {
        this.result.forwarder_id        = null;
        this.result.storekeeper_id = null;
      },
      clearData() {
        this.result.forwarder_id        = null;
        this.result.from_storekeeper_id = null;
        this.result.to_storekeeper_id   = null;
        this.result.storekeeper_id      = null;
        this.result.to_chief_id         = null;
        this.result.driver_id           = null;
        this.result.from_stock_id       = null;
        this.result.to_stock_id         = null;
        this.result.stock_id            = null;
      },

      validateFreights() {
         if (this.$route.params.id && this.$route.params.id != 'new') return;
          let stock     = this.stocks.find(item => parseInt(item.id) === parseInt(this.result.stock_id)),
              fromStock = this.fromStocks.find(item => parseInt(item.id) === parseInt(this.result.from_stock_id)),
              toStock   = this.toStocks.find(item => parseInt(item.id) === parseInt(this.result.to_stock_id));

          this.canSave           = true;
          this.hasFreightsErrors = false;
          this.freightsErrors    = [];
          this.freightsWarnings  = [];

          let valid = RoutelistValidator.validate(this.$root, this.selectedFreights, this.result.forward_type, stock, fromStock, toStock, this.result.date);
          if (valid && (valid.hasFreightsErrors || valid.freightsWarnings)) {
            this.hasFreightsErrors = valid.hasFreightsErrors;
            this.freightsErrors    = valid.freightsErrors;
            this.freightsWarnings  = valid.freightsWarnings;
            this.canSave           = valid.canSave;
          }
          //Вся логика проверки перенесена в RoutelistValidator, код ниже не актуален, но временно не удаяю (03.03.2021)
          return;

          this.hasFreightsErrors = false;
          this.canSave = true;
          this.selectedFreights.forEach(freight => {
            if (!this.freightsErrors[freight.id]) this.freightsErrors[freight.id] = [];
            this.freightsErrors[freight.id] = [];

            if (!this.freightsWarnings[freight.id]) this.freightsWarnings[freight.id] = [];
            this.freightsWarnings[freight.id] = [];

            let message   = {e: null, w: null, c: true};
            let validator = [
              this.checkFreightData(freight),
              this.checkFreightLocation(freight),
              this.checkFreightTracking(freight),
              this.checkFreightStatus(freight),
              this.checkFreightDate(freight.deal),
              this.checkFreightCompleted(freight),
              this.checkDealCustomers(freight.deal, freight.id),
              this.checkDealCustomerDebt(freight.deal, freight.id)
            ];

            validator.map(item => {
              if (item.e)  this.freightsErrors[freight.id].push(item.e);
              if (item.w)  this.freightsWarnings[freight.id].push(item.w);
              if (!item.c) this.canSave = false;
            });

            this.freightsErrors[freight.id]   = this.array_unique(this.freightsErrors[freight.id]);
            this.freightsWarnings[freight.id] = this.array_unique(this.freightsWarnings[freight.id]);

            if (this.freightsErrors[freight.id] && this.freightsErrors[freight.id].length) this.hasFreightsErrors = true;
          });
      },
      checkFreightStatus(freight) {
        if (!this.result.forward_type) return {e: null, w: null, c: true};
        if (freight.status && parseInt(freight.status.tracking_type) === 6) return {e: 'Груз уже выдан получателю.', w: null, c: false};
        return {e: null, w: null, c: true};
      },
      checkFreightTracking(freight) {
        if (!this.result.forward_type) return {e: null, w: null, c: true};
        //Если тип перевозки не "Забор у отправителя" и нет трекинга, то такой груз нельзя добавлять в МЛ
        if (parseInt(this.result.forward_type) != 1 && (!freight.currenttracking || !freight.currenttracking.id))
          return {e: 'У груза не установленно текущее местоположение. Перевозка невозможна.', w: null, c: false};

        return {e: null, w: null, c: true};
      },
      checkFreightLocation(freight) {
        if (!this.result.forward_type) return {e: null, w: null, c: true};
        let message = {e: null, w: null, c: true};

        if (parseInt(this.result.forward_type) === 2) { //Если тип - Внутренняя перевозка
          if (!freight.currenttracking || !freight.currenttracking.id || !freight.currenttracking.stock_id) {
            return {e: 'У груза не установленно текущее местоположение. Перевозка невозможна.', w: null, c: false};
          } else {
            if (parseInt(freight.currenttracking.stock_id) != parseInt(this.result.from_stock_id)) 
              return {e: 'Текущее местоположение груза отличается от выбранного склада отправления. Перевозка невозможна.', w: null, c: false};
          }
        }

        if (this.result.stock_id && parseInt(this.result.forward_type) === 1) { //Если тип - Экспедирование

          let ForwardType = ((freight.current_forward_method) ? parseInt(freight.current_forward_method) : this.getFreightForwardMethod(freight));
          let Stock = this.stocks.find(item => parseInt(item.id) === parseInt(this.result.stock_id));
          if (!Stock) return {e: 'Не установлен склад экспедирования. Перевозка невозможна.', w: null, c: false};

          if (!ForwardType || parseInt(ForwardType) === 0) { //Если вернулось 0, значит ошибка
            return {e: 'Экспедирование груза невозможно ни в одном из пунктов, проверьте данные груза. Перевозка невозможна.', w: null, c: false};
          } else if (parseInt(ForwardType) == 1) { //Проверяем пункт отправления
            if (freight.deal && freight.deal.from_address && freight.deal.from_address.city) {
              if (parseInt(Stock.city.zone_id) !== parseInt(freight.deal.from_address.city.zone_id))
                return {e: 'Указанный город и направление не совпадают с городом и направленем отправления груза.', w: null, c: false};

              if (parseInt(Stock.city.id) !== parseInt(freight.deal.from_address.city.id)) 
                return {e: null, w: 'Указанный город не совпадает городом отправления груза.', c: true};

            } else return {e: 'У груза некорректно установлен адрес отправления, проверьте данные груза. Перевозка невозможна.', w: null, c: false};

          } else if (parseInt(ForwardType) == 2) { //Проверяем пункт назначения
            if (freight.deal && freight.deal.to_address && freight.deal.to_address.city_id) {
              if (parseInt(Stock.city.zone_id) !== parseInt(freight.deal.to_address.city.zone_id))
                return {e: 'Указанный город и направление не совпадают с городом и направленем назначения груза.', w: null, c: false};

              if (parseInt(Stock.city.id) !== parseInt(freight.deal.to_address.city.id)) 
                return {e: null, w: 'Указанный город не совпадает городом назначения груза.', c: true};

            } else return {e: 'У груза некорректно установлен адрес назначения, проверьте данные груза. Перевозка невозможна.', w: null, c: false}; 
          }
        }

        return message;
      },
      checkFreightDate(deal) {
        if (!this.result.forward_type) return {e: null, w: null, c: true};
        let date    = (deal.forwarding_date_from) ? this.$root.moment(deal.forwarding_date_from) : null;
        let current = this.$root.moment(this.result.date);
        let message = {e: null, w: null, c: true};

        if (!date || !this.result.date || !deal.forwarding_date_from) return message;

        switch (parseInt(this.result.forward_type)) {
          case 1: //Экспедирование
            if (current.isAfter(date, 'day'))       message = {e: null, w: 'Выбранная дата позже даты экспедирования груза', c: true};
            else if (current.isBefore(date, 'day')) message = {e: null, w: 'Выбранная дата раньше даты экспедирования груза', c: true};
          break;
          case 2: //Перевозка
            if (current.isBefore(date, 'day')) message = {e: 'Выбранная дата перевозки не может быть раньше даты забора груза', w: null, c: true};
          break;
        }

        return message;
      },
      checkFreightCompleted(freight) {
        if (!this.result.forward_type) return {e: null, w: null, c: true};
        if (
            freight.current_routelist && 
            (!this.$route.params.id || this.$route.params.id == 'new' || parseInt(this.$route.params.id) != parseInt(freight.current_routelist.id)) && 
            !freight.is_current_routelist_completed
        ) return {e: 'Груз ещё не обрработан по предыдущему маршрутному листу. Перевозка невозможна.', w: null, c: false};
        
        return {e: null, w: null, c: true};
      },
      checkDealCustomers(deal, freightId) {
        if (!this.result.forward_type) return {e: null, w: null, c: true};
        let message = {e: null, w: null, c: true};
        if (!deal.sender_id || !deal.recipient_id || !deal.payer_id || !deal.applicant_id) {
          message = {e: 'У заявки не указаны контрагенты', w: null, c: false};

          let customers = [];
          if (!deal.sender_id)    customers.push('отправитель');
          if (!deal.recipient_id) customers.push('получатель');
          if (!deal.payer_id)     customers.push('плательщик');
          if (!deal.applicant_id) customers.push('заявитель');

          if (customers.length) message.e += ': ' + customers.join(', ') + '.';
        }
        return message;
      },
      checkDealCustomerDebt(deal, freightId) {
        if (!this.result.forward_type) return {e: null, w: null, c: true};
        let message = {e: null, w: null, c: true};
        if (parseInt(this.result.forward_type) != 1) return message;
        if (!deal || !deal.payer_id || !deal.payer)  return message;
        if (parseInt(deal.payer.can_issue_freight) == 0) message.w = 'Выдача груза запрещена' + ((deal.payer && deal.payer.name) ? (' для плательщика ' + deal.payer.name) : '');

        return message;
      },
      checkFreightData(freight) {
        if (!freight.size || !freight.weight || !freight.seats_number) 
          return {e: 'У груза не установлен один из обязательных параметров (вес, объём, кол-во мест)', w: null, c: true};

        return {e: null, w: null, c: true};
      },


      getAgents() {
        return this.$store.dispatch('customers/getCustomers', {
          page: 1, order_by: 'id', order_type: 'asc', count: 'all', 
          filter: {model: [['is_agent', '=', 1]], relation: []}, cache: true
        }).then(agents => {
          if (agents && agents.length) this.agents = Object.assign([], agents.map(item => {
            return {
              id: item.id,
              label: item.name + ((item.inn) ? (', ' + item.inn) : ((item.passport_number) ? (', ' + item.passport_number) : ''))
            }
          }));
        });
      },
      getAutos() {
        return this.$store.dispatch('deals/getAutos', {page: 1, order_by: 'id', order_type: 'asc', count: 'all', cache: true}).then(autos => {
          if (autos && autos.length) this.autos = Object.assign([], autos);
        });
      },
      getDrivers() {
        if (this.drivers && this.drivers.length) return new Promise(resolve => resolve(this.drivers));
        return this.$store.dispatch('users/getUsers', {page: 1, order_by: 'id', order_type: 'asc', count: 'all', cache: true, filter: {
          model: [], relation: [['groups', 'code', '=', 'driver']]
        }}).then(drivers => {
          this.drivers = Object.assign([], []);
          if (!drivers || !Array.isArray(drivers)) return [];

          drivers.map(driver => {
            this.drivers.push({
              id: driver.id,
              label: (driver.fio ? driver.fio : '') + (driver.login ? ' (' +  driver.login + ')' : '')// + (groups.length ? ': ' + groups : '')
            });
          });

          return drivers;
        });
      },
      array_unique(array){
        return array.filter(function(el, index, arr) {
            return index == arr.indexOf(el);
        });
      },
      printDoc() {
          let url = this.endpoint + '/print/route_list_a4?route_list_id=' + this.$route.params.id + '&user_id=' + this.user.id
          window.open(url, '_blank');
      },
      getRouteList(id) {
        this.stockErrors = [];
        this.$store.commit('showProgressBar', this.loadKey);
        return this.$store.dispatch('deals/getRouteListById', id).then(r => {
          if (r) {
            
            if (r && r.id) this.$store.commit('setTitle', ('Маршрутные листы | Маршрутный лист ' + r.id));
            this.routeList = Object.assign({}, r);
        
            this.result.id     = this.routeList.id;
            this.result.weight = this.routeList.weight;
            this.result.volume = this.routeList.size;
            this.result.seats  = this.routeList.seats;

            if (!this.routeList.date) this.result.date = moment().format('YYYY-MM-DD') + 'T00:00:00.000Z';
            else this.result.date   = this.routeList.date + 'T00:00:00.000Z';

            this.result.driver_id     = parseInt(this.routeList.driver_id);
            this.result.forwarder_id  = parseInt(this.routeList.forwarder_id);
            this.result.forward_type  = this.routeList.type;
            this.result.city          = this.routeList.city;
            this.result.from_stock_id = parseInt(this.routeList.from_stock_id);
            this.result.to_stock_id   = parseInt(this.routeList.to_stock_id);
            this.result.stock_id   = parseInt(this.routeList.stock_id);
            this.result.auto_id    = parseInt(this.routeList.auto_id);
            this.result.agent_id   = parseInt(this.routeList.agent_id);

            this.result.from_storekeeper_id = parseInt(this.routeList.from_storekeeper_id);
            this.result.to_storekeeper_id   = parseInt(this.routeList.to_storekeeper_id);
            this.result.storekeeper_id      = parseInt(this.routeList.storekeeper_id);
            this.result.to_chief_id         = parseInt(this.routeList.to_chief_id);
            this.result.status              = this.routeList.status;
            this.result.status_id           = parseInt(this.routeList.status_id);
            this.result.storekeeperFrom     = this.routeList.storekeeperFrom;
            this.result.storekeeperTo       = this.routeList.storekeeperTo;
            this.result.storekeeper         = this.routeList.storekeeper;
            this.result.chiefTo             = this.routeList.chiefTo;
            if (this.routeList.trailers && this.routeList.trailers.length)
              this.result.trailers = Object.assign([], this.routeList.trailers.map(auto => auto.id));

            this.$nextTick(() => {
              this.result.freights = [];
              this.routeList.freights.map(freight => this.result.freights.push(freight.id));
              this.prepareFreights();
            });
          }
        }, () => null).catch(() => null).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
      },
      updateRoutelistStatus(id) {
        this.$store.commit('showProgressBar', this.loadKey);
        return this.$store.dispatch('deals/checkRouteListStatus', id).then(r => {
          if (r) this.getRouteList(this.$route.params.id);
        }).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
      },
      prepareFreights() { 
        if (this.routeList && this.routeList.freights) {
          this.selectedFreights   = Object.assign([], this.routeList.freights);
          this.selectedFreightsId = Object.assign([], this.routeList.freights.map(item => item.id));
          this.$store.commit('stock/changeItineraryFreight', this.selectedFreightsId);
        }
      },
      back(e) {
        this.$store.commit('stock/changeItineraryFreight', []);
        if (this.$route.name == 'ItineraryFreights') this.$router.push({name: 'DealsNew', query: this.$route.query});
        else this.$router.push({name: 'Itineraries', query: this.$route.query});
      },
      getFreights() {
        this.currentStockId = null;

        if (this.stateSelectedFreight && this.stateSelectedFreight.length && this.stateSelectedFreight.length != this.selectedFreights.length) {
          this.$store.commit('showProgressBar', this.loadKey);

          this.result.weight = 0;
          this.result.volume = 0;
          this.result.seats  = 0;
          this.result.freights  = [];
          this.selectedFreights = [];
          this.stockErrors = [];

          //Новая логика
          return this.$store.dispatch('deals/getFreightsByIds', {ids: this.stateSelectedFreight, count: 'all'}).then(r => {

            let freights = (r && r.data) ? r.data : []
            if (freights) freights.forEach(item => {
              let itemVolume = this.prepareFreightVolume(item);

              // Увеличиваем значение если необходима обрешетка
              if (parseInt(item.doom) === 1 && this.doomMarkup > 0) {
                item.weight = parseFloat(item.weight) + ((parseFloat(item.weight) * this.doomMarkup) / 100);
                itemVolume  = parseFloat(itemVolume)  + ((parseFloat(itemVolume)  * this.doomMarkup) / 100);
              }

              this.result.weight += parseFloat(item.weight);
              this.result.volume += itemVolume;
              this.result.seats  += parseInt(item.seats_number);
              this.result.freights.push(item.id);
              if (!this.result.forward_type) this.result.forward_type = item.forward_type;
              this.selectedFreights.push(item);
              return this.selectedFreights;
            });
          }).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
          /* Старая логика
          this.selectedFreights = this.allFreights.filter(item => {
            if (this.stateSelectedFreight.indexOf(item.id)+1) {
              let itemVolume = this.prepareFreightVolume(item);

              this.result.weight += parseFloat(item.weight);
              this.result.volume += itemVolume;
              this.result.seats  += parseInt(item.seats_number);
              this.result.freights.push(item.id);
              if (!this.result.forward_type) this.result.forward_type = item.forward_type;
              return item;
            }
          });
          */
        }
      },
      /**
       * Проверяет надо выдать груз клиенту или забрать у клиента
       * Метод только для типа МЛ - "Экспедирование"
       */
      getFreightForwardMethod(freight) {
        // 1 - Терминал, 2 - Экспедирование

        //Если метод отправки со склада и метод доставки до склада, то этот груз нельзя экспедировать и надо вернуть fase (интикатор ошибки)
        if (parseInt(freight.deal.delivery_method_from) === 1 && parseInt(freight.deal.delivery_method_to) === 1) return 0;

        //Если у груза ещё нет трекинга, значит он сейчас находится у клиента и его ещё не забрали
        //Тут других вариантов быть не может, груз/заявка без трекинга создаётся только в одном случае - для экспедирования в пункте отправления
        if (!freight.currenttracking || !freight.currenttracking.id) {
          //Если метод отправки выбран "Экспедирование" значит метод экспедирования - Забор
          if (parseInt(freight.deal.delivery_method_from) === 2) return 1;
          else return 0; //Если метод отправки "Со склада", а трекинга нет, значит этот груз с ошибкой (такой ситуации быть не должно), следовательно груз нельзя экспедировать
        }
        //Если трекинг есть, значит его либо уже забрали у клиента, либо клиент сам его сдал на склад.
        //В обоих случаях экспедирование может быть только в пункте назначения
        else {
          //Если метод доставки выбран "Экспедирование" значит метод экспедирования - Выдача
          if (parseInt(freight.deal.delivery_method_to) === 2) return 2;
          else return 0; 
          //Если метод доставки "До склада", значит мы не можем экспедировать этот груз т.к. 
          //в пункте отправления он уже обработан, а в пункте назначения экспедирование не требуется
        }

        return 0;
      },
      getSizeUnits(unit) {
        let res = 0;
        switch (unit) {
          case 'm':  res = 'м'; break;
          case 'sm': res = 'см'; break;
          case 'mm': res = 'мм'; break;
          default:   res = 'м';
        }
        return res;
      },
      prepareFreightVolume(freight) {
        let itemSize = 0;
        switch (freight.size_units) {
          case 'м':  itemSize = parseFloat(freight.size); break;
          case 'm':  itemSize = parseFloat(freight.size); break;
          case 'см': itemSize = parseFloat(freight.size) / 100; break;
          case 'sm': itemSize = parseFloat(freight.size) / 100; break;
          case 'мм': itemSize = parseFloat(freight.size) / 1000; break;
          case 'mm': itemSize = parseFloat(freight.size) / 1000; break;
          default: itemSize = parseFloat(freight.size);
        }
        return itemSize;
      },

      getResponsibles(stockId, groups) {
        this.$store.commit('showProgressBar', this.loadKey);
        return this.$store.dispatch('stock/getStockResponsiblesFilter', {
          id: stockId,
          groups: groups,
          cache: true
        }).then(r => {
            if (!r || !r.length) {
                this.stockErrors.push('К указанному складу, не добавлен ни один ответственный');
                return null;
            } else return Object.assign([], r.map(item => {
              let groups = [];
              if (item.groups && item.groups.length) item.groups.map(item => groups.push(item.name));
              groups = groups.join(', ');
              return {
                id: item.id, 
                login: (item.fio ? item.fio : '') + (item.login ? ' (' +  item.login + ')' : '') + (groups.length ? ': ' + groups : '')
              }
            }));
        }, r => null).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
      },
      filterFreight(searchString) {
        if (searchString.length >= 3) return this.$store.dispatch('stock/searchFreights', {
            filter : {model: [['traking_number', '%', searchString]], relation: []}
        });
      },
      removeFreight(freight) {
        if (!freight || !freight.id) return;

        let stateSelectedFreight = Object.assign([], this.stateSelectedFreight), index = -1;
        index = stateSelectedFreight.indexOf(freight.id);

        if ((index+1)) {
          this.result.removed.push(freight.id);
          stateSelectedFreight.splice(index, 1);
          this.$store.commit('stock/changeItineraryFreight', stateSelectedFreight);
          this.$store.commit('showSnackbar', ['Груз удалён из маршрутного листа', 6000, 'success']);
        }
      },
      getStocks() { //получение всех складов
        this.$store.commit('showProgressBar', this.loadKey);
        return this.$store.dispatch('stock/getStocks', {page: 1, order_by: 'id', order_type: 'asc', count: 'all', cache: true})
          .finally(() => this.$store.commit('hideProgressBar', this.loadKey));
      },
      getFromStocks() {
          return this.$store.dispatch('stock/getFromStocks');
      },
      getToStocks() {
          return this.$store.dispatch('stock/getToStocks');
      },
      getCity() {
        if (!this.result || !this.result.forward_type || !this.stocks || !this.stocks.length) return '';
        let stock = null;
        switch ( parseInt(this.result.forward_type) ) {
          case 1: //Экспедирование
            stock = this.stocks.find(stock => parseInt(stock.id) === parseInt(this.result.stock_id));
          break;
          case 2: //Перевозка
            stock = this.stocks.find(stock => parseInt(stock.id) === parseInt(this.result.to_stock_id));
          break;
        }
        if (!stock || !stock.city || !stock.city.name) return '';
        return stock.city.name;
      },
      save() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) return;
          this.$store.commit('showProgressBar', this.loadKey);
          this.result.city = this.getCity();
        
          let data = Object.assign({}, this.result);
          this.$store.dispatch('stock/saveItinerary', data).then(r => {
            if (r) {
              this.$store.commit('showSnackbar', ['Маршрутный лист успешно сохранён', 6000]);
              this.back();
            }
          }).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
        });
      },

      acceptAuto() {
        if (!this.$route.params.id || this.$route.params.id == 'new') return;
        this.$root.$emit('z-alert', 'Вы уверены, что хотите принять машину на складе?', 
        ('Пожалуйста, убедитесь что все грузы в рамках этого маршрутного листа успешно выданы на перемещение на склад назначения.' + 
        '<hr>Эту функцию следует использовать только в случае возникнования ошибок при приёме машины и грузов кладовщиком на складе назначения.'),
        () => {
          this.$store.commit('showProgressBar', this.loadKey);
          return this.$store.dispatch('deals/setRouteListStatus', {
            id: this.$route.params.id,
            status: 'accepted'
          }).then(r => {
            if (r) this.getRouteList(this.$route.params.id);
          }).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
        });
      },

      getDoomMarkup() {
        if (this.doomMarkup > 0) return new Promise((resolve) => resolve(this.doomMarkup));
        else return this.$store.dispatch('cost/getCostParam', 'doom_markup').then(r => {
          if (r && r.value) this.doomMarkup = parseFloat(r.value);
          else this.doomMarkup = 0;
        });
      },
      round(num, decimals = 2) {
        const factor = Math.pow(10, decimals);
        return Math.round(num * factor) / factor;
      },
      calcDimensions(freights, i) {
        let result = { weight: 0, volume: 0, seats: 0 };

        Object.values(freights).filter((item, n) => n <= i).forEach(freight => {
          let itemVolume = this.round(this.prepareFreightVolume(freight));
          let itemWeight = this.round(freight.weight ? freight.weight : 0);

          // Увеличиваем значение если необходима обрешетка
          if (parseInt(freight.doom) === 1 && this.doomMarkup > 0) {
            itemWeight = itemWeight + ((itemWeight * this.doomMarkup) / 100);
            itemVolume = itemVolume + ((itemVolume * this.doomMarkup) / 100);
          }

          result.weight = this.round(result.weight) + this.round(itemWeight);
          result.volume = this.round(result.volume) + this.round(itemVolume);
          result.seats  = result.seats  + parseInt(freight.seats_number);
        })

        return {
          weight: this.round(result.weight).toFixed(2),
          volume: this.round(result.volume).toFixed(2),
          seats:  parseInt(result.seats),
        }
      },
      calcDimensionsStr(freights, i) {
        let r = this.calcDimensions(freights, i)
        return `${r.weight}кг ${r.volume}м<sup>3</sup> ${r.seats}`
      }
    },
    mounted() {
      this.$nextTick(() => this.init());
      this.$root.$on('update-itinerary-form', (id) => {
        if (parseInt(id) == parseInt(this.$route.params.id)) this.init();
      });
    }
  }
</script>
<style lang="sass">
  #itinerary
    .acceptauto
      width: auto
      margin: 0 0 0 10px
    .md-layout-item.entity-head-left
      display: flex
      align-items: center
      justify-content: flex-start
      .status
        margin: 0 5px 0 10px
    .freight-list-title
      margin: 0 0 5px 0
      .title
        margin: 0 10px 0 0
    .freight-list
      display: flex
      flex-direction: column
      gap: 10px
      .freight-list__intermediate-dimensions
        display: none
        font-size: 12px
        padding: 0 10px
      .freight-list-item__container
        margin: 0 0 10px 0
        .freight-list-item
          margin: 0
        .freight-list-item__errors
          padding: 5px 0 0 0
          .freight-list-item__error
            display: flex
            align-items: center
            justify-content: flex-start
            .error-text
              color: red
              font-size: 12px
              line-height: 12px
            .md-icon
              color: red
              font-size: 20px !important
              margin: 0 2px 0 0
              width: 20px
              height: 20px
              min-height: 20px
              min-width: 20px
        .md-card-header
          padding: 10px
          .md-title
            display: flex
            align-items: center
            justify-content: space-between
            margin: 0
            font-size: 14px
            line-height: 14px
            position: relative
            sup
              font-size: 14px
              line-height: 0px
            .close-btn
              display: flex
              align-items: center
              justify-content: center
              width: 22px
              height: 22px
              opacity: 0
              position: absolute
              top: -22px
              right: -22px
              background: rgba(255, 49, 49, 0.91)
              border-radius: 100%
              transition: 0.25s ease-in-out
              .md-icon
                color: #fff
                width: 18px
                height: 18px
                min-width: 18px
                font-size: 18px !important
        .md-card-content
          padding: 0 10px 10px 10px
        .freight-list-item__content
          display: flex
          flex-wrap: wrap
          .freight-list-item__content-item
            width: 100%
            display: flex
            align-items: flex-start
            justify-content: space-between
            .place
            .date
      .freight-list-item__container:hover
        .md-card-header
          .close-btn
            opacity: 1
      .freight-list-item__container.has-error
        .freight-list-item
          border: 1px solid rgb(255, 113, 113)
            
    .error
      color: red
    .success
      color: green

    .direction-container
      background: #FAFAFA
      padding: 20px 10px 15px 10px
      margin: 0 -10px 10px -10px
    .direction-area__container
      display: flex
      align-items: flex-start
      justify-content: space-between
      flex-wrap: wrap
      .direction-area
        width: calc(50% - 5px)
        &.full-width
          width: 100%

    .sum-data-title
      margin: 0 0 10px 0
    .sum-data
      display: flex
      align-items: stretch
      justify-content: space-between
      margin: 0 0 20px 0
      .sum-data-item
        display: flex
        align-items: center
        justify-content: center
        background: #FAFAFA
        border: 1px solid #2196F3
        box-sizing: border-box
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25)
        border-radius: 3px
        height: 33px
        width: calc(33% - 10px)
        font-size: 12px
        line-height: 12px
        span
          margin: 0 5px 0 0
        sup
          line-height: 0px
      .sum-data-item:nth-child(2)
        margin: 0px 10px
</style>



// WEBPACK FOOTER //
// ItineraryFreights.vue?7e809e04